module.exports = __webpack_public_path__ + "static/media/internship-avatar-testimonies-1.6caf6d6f.png";